import React from '../services/React';
import './ErrorMessage.css';

function AlertIcon() {
  return (
    <svg
      style={{ marginBottom: '-3px' }}
      width="14"
      height="18"
      viewBox="-503.5 377 18 14"
    >
      <path
        fill="#1D2D3C"
        d="M-486.1 389.4l-6.8-10.7c-.4-.6-1-.9-1.7-.9s-1.3.3-1.7.9l-6.8 10.7c-.4.7 0 1.6.8 1.6h15.2c1 0 1.5-.9 1-1.6zm-16 .6l6.8-10.8c.3-.4.7-.5.8-.5.2 0 .6 0 .8.5l6.8 10.8h-15.2z"
      />
      <path
        fill="#1D2D3C"
        d="M-495 389h1v-1h-1zM-495 384.1v2.9h.4l.6-2.9V382h-1z"
      />
    </svg>
  );
}

function ErrorMessage({ title, message }) {
  return (
    <div className="ErrorMessage">
      <header className="ErrorMessage__Header">
        <AlertIcon /> {title}
      </header>
      <div className="ErrorMessage__Text">
        {message}
      </div>
    </div>
  );
}

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/commons/components/ErrorMessage.jsx